import { TripleShift } from "../types/Shift";

export type StoppagesListFilters = {
  status: string;
  jobType: number | null;
  machineName: string;
  zoneId: number | null;
  unverifiedOnly: boolean;
};

export const UNFILTERED_STOPPAGES: StoppagesListFilters = {
  status: "Down & Up",
  jobType: null,
  machineName: "",
  zoneId: null,
  unverifiedOnly: false,
};

/**
 * The Stoppages list's query key. Positional, so every filter needs a slot here and the offline
 * fallback below stays the same entry the page writes when nothing is filtered.
 */
export const stoppagesListQueryKey = (
  dateIso: string | null,
  shift: TripleShift,
  filters: StoppagesListFilters
) => [
  'stoppages', 'list', dateIso, shift,
  filters.status, filters.jobType, filters.machineName, filters.zoneId, filters.unverifiedOnly,
];

export const unfilteredStoppagesListCacheKey = (dateIso: string | null, shift: TripleShift) =>
  ['dataTable', ...stoppagesListQueryKey(dateIso, shift, UNFILTERED_STOPPAGES), 'all', false, null];
